// import

import {useEvents} from '@sitearcade/react-hooks';
import Router from 'next/router';
import type {MouseEvent} from 'react';

import {useContactFormTrigger} from 'modules/Contact';

// vars

const arcRx = /^((https?:\/\/)?(www\.(\w+\.)*)?sitearcade\.com\/?|\/)/;

// fns

const ignoreEvent = (ev: MouseEvent) => {
  switch (true) {
    case ev.defaultPrevented:
      return true;
    case ev.button && ev.button !== 0:
      return true;
    case ev.metaKey:
      return true;
    case ev.ctrlKey:
      return true;
    case ev.shiftKey:
      return true;

    default:
      return false;
  }
};

const findNearestLink = (el?: Node | null) => (
  el ? el.nodeName === 'A' ? el : findNearestLink(el.parentNode) : null
);

const ignoreElement = (el?: HTMLAnchorElement) => {
  switch (true) {
    case !el:
      return true;
    case !!el?.download:
      return true;
    case !el?.href:
      return true;
    case !arcRx.test(el?.href ?? ''):
      return true;

    default:
      return false;
  }
};

// export

export function useRouteCapture() {
  const openContact = useContactFormTrigger();

  return useEvents((ev) => {
    if (ignoreEvent(ev as unknown as MouseEvent)) {
      return;
    }

    const el = findNearestLink(ev.target as Node);

    if (ignoreElement(el)) {
      return;
    }

    el.blur();
    ev.preventDefault();

    const href = el.href.replace(arcRx, '/');

    if (href.startsWith('/contact')) {
      return openContact(true);
    }

    Router.push(href);
  }, ['click', 'keydown']);
}

